<!--
  Un chiffre, à l'un des trois niveaux de la hiérarchie du module.

  Le module portait TROIS implémentations de la même tuile : `.h2-step`
  (Overview), `.sx-kpi` (SumalApv) et un `style=` en dur répété trois fois dans
  ParcelDetail — avec des rayons, des bordures et surtout des graisses
  différentes (300 contre 600 à taille égale). Les deux tableaux de bord
  n'avaient donc pas le même chiffre héros. Une seule implémentation, trois
  niveaux : hero (l'unique chiffre qui compte), tile (les grandeurs), mini
  (le contexte).
-->
<template>
  <div class="hv2-stat" :class="[`hv2-stat--${tier}`, tone ? `is-${tone}` : '']">
    <div class="hv2-stat-value">
      {{ value }}<span v-if="unit" class="hv2-unit">{{ unit }}</span>
    </div>
    <div class="hv2-stat-label">{{ label }}</div>
    <div v-if="sub" class="hv2-stat-sub">{{ sub }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HvStat',
  props: {
    tier: { type: String, default: 'tile' },   // hero | tile | mini
    value: { type: [String, Number], required: true },
    unit: { type: String, default: '' },
    label: { type: String, default: '' },
    sub: { type: String, default: '' },
    tone: { type: String, default: '' }        // '' | warn | danger
  }
}
</script>
